import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Topbar from "../../components/Topbar";
import Leftbar from "../../components/Leftsidebar";
import { Link } from "react-router-dom";
import Loaderspinner from "../../components/Loader";
import { createResourceChecklist, showToast } from "../Utils/utils";

const CreateChecklist = () => {
    const { id } = useParams()
    const [loading, setLoading] = useState(false)
    const [showSidebar, setShowSidebar] = useState(false);
    const [title, setTitle] = useState("");
    const [subtitle, setSubtitle] = useState("");
    const [coverFile, setCoverFile] = useState(null);
    const [checklistFile, setChecklistFile] = useState(null);

    const handleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    const handleSidebarClose = () => {
        setShowSidebar(false);
    };

    const onCoverChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setCoverFile(file)
    };
    const onFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setChecklistFile(file)
    }

    const isFormValid =
        title.trim() &&
        subtitle.trim() &&
        checklistFile

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true)
            const formData = new FormData();
            formData.append("resource_id", id);
            formData.append("title", title);
            formData.append("sub_title", subtitle);
            formData.append("cover", coverFile);
            formData.append("file", checklistFile);

            const response = await createResourceChecklist({ formData });
            if (response.status == 200) {
                showToast("Checklist added successfully", "success")
                setTimeout(() => {
                    window.location.href = `/manage-resource/${id}`;
                }, [1000])
            } else {
                showToast(response?.data?.message || response?.data, "error")
            }

        } catch (error) {
            console.log(error, "error...");
            setLoading(false)
            showToast(error.message, "error")
        } finally {
            setLoading(false)
        }
    };

    return (
        <>
            {loading && <Loaderspinner />}
            <div class="g-sidenav-show  bg-gray-100 min-vh-100">
                <div id="wrapper">
                    <Leftbar showSidebar={showSidebar}
                        handleSidebarClose={handleSidebarClose} />
                    <main className="main-content border-radius-lg">
                        <Topbar handleSidebar={handleSidebar} />
                        <div>
                            <div className="header header-bg pb-6">
                                <div className="container-fluid">
                                    <div className="header-body">
                                        <div className="row align-items-center py-4">
                                            <div className="col-lg-6 col-7">
                                                <nav
                                                    aria-label="breadcrumb"
                                                    className="d-none d-md-inline-block ml-md-4"
                                                >
                                                    <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                                                        <li className="breadcrumb-item">
                                                            <Link to="/dashboard">
                                                                <i className="fas fa-home" />
                                                            </Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to="/resources"><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Resources</span></Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to={`/manage-resource/${id}`}><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Manage Resource</span></Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to=""><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Create Checklist</span></Link>
                                                        </li>
                                                    </ol>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="container-fluid mt--6">
                                <div className="row">
                                    <div className="col">
                                        <form className="card mb-4" onSubmit={(e) => handleSubmit(e)}>
                                            <div className="card-body">

                                                <div className="form-group">
                                                    <label>Title</label>
                                                    <input
                                                        className="form-control"
                                                        value={title}
                                                        onChange={(e) => setTitle(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Subtitle</label>
                                                    <input
                                                        className="form-control"
                                                        value={subtitle}
                                                        onChange={(e) => setSubtitle(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group mt-3">
                                                    <label>Cover Image</label>
                                                    <div className="d-flex gap-4">
                                                        <label className="btn btn-outline-primary mb-0" style={{ height: "36px" }}>
                                                            Browse
                                                            <input hidden type="file" accept="image/*" onChange={onCoverChange} />
                                                        </label>
                                                        {coverFile && (
                                                            <>
                                                                <div className="mt-2">
                                                                    {coverFile?.name}
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="form-group mt-3">
                                                    <label>File</label>
                                                    <div className="d-flex gap-4">
                                                        <label className="btn btn-outline-primary mb-0" style={{ height: "36px" }}>
                                                            Browse
                                                            <input hidden type="file" accept="image/*,.pdf" onChange={onFileChange} />
                                                        </label>
                                                        {checklistFile && (
                                                            <>
                                                                <div className="mt-2">
                                                                    {checklistFile?.name}
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>

                                                <button type="submit" className="btn cta-btn mt-4" disabled={loading || !isFormValid}>
                                                    Create
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </>
    );
};

export default CreateChecklist;
